// Normalize gaps and duplicate order values without changing stage identity or status.
export function stageOrderUpdates(stages, id, direction) {
  const rows = stages.filter(stage => stage.id)
  const from = rows.findIndex(stage => stage.id === id)
  const to = from + direction
  if (from < 0 || ![-1, 1].includes(direction) || to < 0 || to >= rows.length) return []
  ;[rows[from], rows[to]] = [rows[to], rows[from]]
  return rows.map((stage, ordem) => ({ id: stage.id, ordem }))
}
